import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksVendorSection', {
    addNewVendor: '+ New Vendor',
    mailingAddressFieldTitle: 'Mailing address',
    mailingAddressPlaceholder: 'Enter the mailing address',
    sectionName: 'Vendor details',
    vendorFieldTitle: 'Vendor',
    vendorPlaceholder: 'Select a Vendor',
    multipleVendorsWarning: 'Multiple vendors detected. Check suggested vendors.',
    differentCurrencyWarningLabel1: 'Bill currency:',
    differentCurrencyWarningLabel2: 'File currency:',
    differentCurrencyWarningDescription: 'Bill currency differs from File currency.',
});
